import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ChevronLeftThinIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'defaultColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M9.354,11.707 C9.354,11.707 7.90266667,10.2556667 5,7.353 L9.354,3 L10.061,3.707 L6.414,7.353 L10.061,11 C9.58966667,11.4713333 9.354,11.707 9.354,11.707 Z"
        data-testid="icon-breadcrumbChevronLeft"
        fill={customColour}
        className={styles[className]}
        fillRule="nonzero"
      />
    </Icon>
  )
}
